/**
 * Platform detection for cross-platform shortcuts.
 *
 * `mod` resolves to ⌘ on macOS, Ctrl elsewhere — matching the convention of
 * Linear, Slack, Notion, GitHub, Vercel, Stripe, Raycast. The literal binding
 * differs by platform; the INTENT is unified.
 *
 * Per E-023 §D — "device-appropriate equivalents" of the same intent.
 */
export function detectPlatform() {
    if (typeof navigator === "undefined")
        return "other";
    const p = navigator.platform || "";
    const ua = navigator.userAgent || "";
    if (/Mac/.test(p) || /Mac/.test(ua))
        return "mac";
    if (/Win/.test(p) || /Win/.test(ua))
        return "windows";
    if (/Linux/.test(p) || /Linux/.test(ua))
        return "linux";
    return "other";
}
/** Returns the modifier key flag to check for the platform's "mod". */
export function modKeyHeld(e) {
    const platform = detectPlatform();
    return platform === "mac" ? e.metaKey : e.ctrlKey;
}
/** Returns the human-readable shortcut label for the current platform. */
export function modLabel() {
    return detectPlatform() === "mac" ? "⌘" : "Ctrl";
}
//# sourceMappingURL=platform.js.map